import React from 'react';
import Sidebar from './Sidebar';

const Layout = ({ children, showSidebar = true }) => {
    return (
        <div className="app-layout">
            {showSidebar && <Sidebar />}
            <main className={`main-content ${showSidebar ? 'with-sidebar' : ''}`}>
                {children}
            </main>
        </div>
    );
};

export default Layout;

